import { Input } from "antd";
import moment from "moment";
import React from "react";
import { openNotification } from "../../../utils/Notifactions";

interface IProps {
  texto: any;
  setTexto: any;
  alltexto: any;
  name: string;
  año?: number;
  disabled?: boolean;
  max?: number;
  placeholder?: string;
}

export const InputNumero: React.FC<IProps> = (props: IProps) => {
  return (
    <Input
      disabled={props.disabled}
      value={props.texto}
      maxLength={props.max}
      placeholder={props.placeholder}
      onChange={(e) => {
        e.target.value = e.target.value.replace(/\D/, "");
        if (props.año) {
          if (parseInt(e.target.value) > parseInt(moment().format("YYYY"))) {
            openNotification({
              titulo: "Error",
              descripcion: "La fecha digitada es mayor a la actual",
              placement: "bottomRight",
            });
            return props.setTexto({ ...props.alltexto, [props.name]: e.target.value.substring(0, 3) });
          }
        }
        props.setTexto({ ...props.alltexto, [props.name]: e.target.value });
      }}
    />
  );
};
